import $ from 'jquery';
import React, {useRef} from 'react';

import {SPREADSHEET_MIME_TYPE} from 'bulk-import/SpreadsheetBulkImportConstants';
import notifications from 'notifications';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';

interface UploadPreviewBaseFileButtonProps {
  setBaseFile: (file: File) => void;
}

export default function UploadPreviewBaseFileButton(props: UploadPreviewBaseFileButtonProps): JSX.Element {
  const fileInputRef = useRef(null);
  return (
    <>
      <input
        type="file"
        multiple={false}
        className="hidden"
        ref={fileInputRef}
        onChange={(e) => {
          if (e.target.files == null || e.target.files.length === 0) {
            return;
          }
          if (e.target.files.length > 1) {
            notifications.error(`Please upload only one file. \
          Multiple file upload is not supported for this input.`);
          }
          props.setBaseFile(e.target.files[0]);
        }}
        accept={SPREADSHEET_MIME_TYPE}
      />
      <Button
        className="pull-right"
        buttonStyle={ButtonStyle.TERTIARY_GRAY}
        icon="upload"
        onClick={() => {
          $(fileInputRef.current!).click();
        }}
        size={ButtonSize.SMALL}
      />
    </>
  );
}
